import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import Avatar from 'material-ui/Avatar';
import { avatarStyles, UserName, Role } from './styles';
import ProfileDropDown from './ProfileDropDown';
import config from '../../../config/config'
import { displayRole } from '../../../lib/lib'

class Profile extends Component {
  constructor (props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null
    };
  }

  handleClick = (e) => {
    e.preventDefault();
    const node = findDOMNode(this);
    this.setState({
      open: true,
      anchorEl: node
    });
  }

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  }

  render () {
    return (
      <div className='h-100 flex items-center pr3 pointer' onClick={this.handleClick}>
        <div className='tr pr3 flex flex-column justify-between'>
          <UserName>{this.props.name}</UserName>
          <Role>{displayRole(this.props.location, this.props.role)}</Role>
        </div>
        <Avatar
          style={avatarStyles}
          src={ this.props.direct ? "https://" + config.API_HOST + "/api/v1/image/" +  this.props.name : "https://" + config.API_HOST + "/api/v1/image/" +  this.props.user_id }
          size={30}
        />
        <ProfileDropDown
          direct={this.props.direct}
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.handleRequestClose}
          accountType={this.props.accountType}
          logoutUser={this.props.logoutUser}
          logoutSuccess={this.props.logoutSuccess}
          recieveLoginstatus={this.props.recieveLoginstatus}
          shouldRedirectUser={this.props.shouldRedirectUser}
          user_id={this.props.user_id}
          name={this.props.name}
          email={this.props.email}
          role={this.props.role}
          location={this.props.location}
        />
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/Profile.js